import { initializeApp } from 'firebase/app';
import { isSupported, getMessaging, getToken } from 'firebase/messaging';

import { ConfigurationResponseDto } from 'theSource/queries';
import { api } from './api';

type Config = Pick<ConfigurationResponseDto, 'firebaseOptions' | 'vapidKey'>;

const initPushSubscription = ({ firebaseOptions, vapidKey }: Config) => {
  const firebaseApp = initializeApp(firebaseOptions);
  const messaging = getMessaging(firebaseApp);

  navigator.serviceWorker.ready
    .then((serviceWorkerRegistration) =>
      getToken(messaging, {
        serviceWorkerRegistration,
        vapidKey,
      })
    )
    .then((token) =>
      api.post('/push_registrations', {
        push_key: token,
      })
    );
};

export const getNotificationsPermission = (config: Config) => {
  isSupported().then(() => {
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          initPushSubscription(config);
        }
      });
    }
  });
};
